import { inject, model } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ModelBase } from './modelBase';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { StoreBase } from './storeBase';
import { REQUIRE_AUTH } from '../../interceptors/auth-context';

export abstract class ServiceBase<T extends ModelBase> {
  public baseUrl = environment.apiUrl;
  private apiUrl = environment.apiUrl;
  public http = inject(HttpClient);
  private _signalStore: StoreBase<T>;

  constructor(protected specificUrl: string, public signalStore: StoreBase<T>) {
    this.apiUrl += specificUrl;
    this._signalStore = signalStore;
  }

  public getStore(): StoreBase<T> {
    return this._signalStore;
  }

  protected getOne<T extends ModelBase>(): Observable<T> {
    return this.http.get<T>(this.apiUrl);
  }

  protected getAll<T extends ModelBase>(): Observable<T[]> {
    return this.http.get<T[]>(this.apiUrl);
  }

  post<T extends ModelBase>(model: T): Observable<T> {
    return this.http.post<T>(this.apiUrl, model);
  }

  postGeneric<Req, Res>(body: Req, url: string | null = null): Observable<Res> {
    return this.http.post<Res>(url ?? this.apiUrl, body);
  }

  updateEntity<T extends ModelBase>(
    id: number | string,
    model: T
  ): Observable<T> {
    return this.http.put<T>(`${this.apiUrl}/${id}`, model, {
      context: new HttpContext().set(REQUIRE_AUTH, true),
    });
  }

  deleteEntity<T extends ModelBase>(id: number | string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  fetchAndSetEntitiesToStore() {
    this.getAll().subscribe((models) => {
      this._signalStore.setModel(models as T[]);
    });
  }

  addNewEntityToSignal<A extends ModelBase>(model: T) {
    this._signalStore.addModel(model);
  }

  deleteAndRemoveEntity(id: number) {
    this.deleteEntity(id).subscribe(() => {
      this.signalStore.removeModel(id);
    });
  }
}
